import CustomContent from './CustomContent'
import styles from './index.module.scss'
import usePlatform from '@/hooks/use-platform'
import { layoutClassNames } from '@/utils/consts'
import classNames from 'classnames'
import { Outlet } from 'react-router-dom'

const AppLayout = () => {
  const { isMobile } = usePlatform()

  return (
    <div className={styles.viewBox}>
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
        <main className={classNames(styles.main, layoutClassNames.mainContent)}>
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default AppLayout
